import { render, staticRenderFns } from "./reviewHistoryList.vue?vue&type=template&id=9b1cc1ec&scoped=true"
import script from "./reviewHistoryList.vue?vue&type=script&lang=js"
export * from "./reviewHistoryList.vue?vue&type=script&lang=js"
import style0 from "./reviewHistoryList.vue?vue&type=style&index=0&id=9b1cc1ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1cc1ec",
  null
  
)

export default component.exports